export const mashedSweetPotatoes = {
  id: "mashedSweetPotatoes",
  link: "/#/recipes/recipes/mashedSweetPotatoes",
  name: "Mashed Sweet Potatoes",
  cuisine: "Azish",
  summary: "Creamy and coconutty mashed purple sweet potatoes",
  inspiration: null,
  quantity: "4 servings",
  time: "30 minutes",
  notes:
    "Adapting this recipe was fairly straightforward. The biggest question was what liquid and fat to add to the mash to help with texture, since I didn't want to use milk as is normal on earth. Coconut milk worked well for that. It brings a strong flavor to the dish, but I find that it works well with the sweet potatoes.",
  quotes:
    "...some kind of purple Azish vegetable mash, which he ate with his fingers. It tasted so good. Had he ever eaten anything so wonderful? He cried over it. (Rhythm of War ch 113)",
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/mashed-purple-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "sweetPotato",
          display: "2 lbs purple sweet potatoes"
        },
        {
          item: "onion",
          display: "1/4 onion"
        },
        {
          item: "garlicClove",
          display: "1 clove garlic"
        },
        {
          item: "ginger",
          display: "1 inch ginger"
        },
        {
          item: "coconut",
          display: "1 tbsp coconut oil"
        },
        {
          item: "coconut",
          display: "1/2 cup coconut milk, plus additional"
        },
        {
          item: "salt",
          display: "1 tsp salt"
        }
      ]
    }
  ],
  steps: [
    "Fill a pot half full of water and bring to a boil over high heat. Peel and chop the sweet potatoes. Add to the water and boil until soft.",
    "Dice the onion. Peel and mince the garlic and ginger. Heat the coconut oil in a pan over medium heat. Add the onions, garlic, and ginger to the pan and saute until the onions are mostly translucent but not yet browning.",
    "Add the coconut milk and salt to the pan. Cook and stir until heated through.",
    "Once the sweet potatoes are cooked, drain the water. Add the coconut milk mixture to the potatoes, then mash thoroughly.",
    "Add additional coconut milk a little at a time, mixing well, until it reaches a consistency that you like. I prefer it thick, so I only add couple tablespoons. Serve warm."
  ]
}
